import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AppComponent } from "./app.component";
import { MainPageComponent } from "./main-page/main-page.component";
import { AboutComponent } from "./about/about.component";
import { SkillsComponent } from "./skills/skills.component";
import { PortfolioComponent } from "./portfolio/portfolio.component";
import { ContactFormComponent } from "./contact/contact.component";
import { WorkTizoComponent } from "./work-tizo/work-tizo.component";
import { WorkHpComponent } from "./work-hp/work-hp.component";
import { WorkLonelyPlanetComponent } from "./work-lonely-planet/work-lonely-planet.component";
import { WorkWhyFiComponent } from "./work-why-fi/work-why-fi.component";
import { WorkSierraComponent } from "./work-sierra/work-sierra.component";
import { WorkDevexHomeComponent } from "./work-devex-home/work-devex-home.component";
import { WorkDevexRegistrationComponent } from "./work-devex-registration/work-devex-registration.component";
import { WorkDevexAppComponent } from "./work-devex-app/work-devex-app.component";

//import { PrivateComponent } from "./private/private.component";

export const router: Routes = [
  { path: "", component: MainPageComponent },
  { path: "about", component: AboutComponent },
  { path: "skills", component: SkillsComponent },
  { path: "portfolio", component: PortfolioComponent },
  { path: "contact", component: ContactFormComponent },
  { path: "tizo", component: WorkTizoComponent },
  { path: "hp", component: WorkHpComponent },
  { path: "mapping", component: WorkLonelyPlanetComponent },
  { path: "why-fi", component: WorkWhyFiComponent },
  { path: "sierra-muebles", component: WorkSierraComponent },
  { path: "devex-home", component: WorkDevexHomeComponent },
  { path: "devex-registration", component: WorkDevexRegistrationComponent },
  { path: "devex-app", component: WorkDevexAppComponent },
  //{ path: "private", component: PrivateComponent },
];

export const routes: ModuleWithProviders = RouterModule.forRoot(router);



// WEBPACK FOOTER //
// ./src/app/app.router.ts